import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { List, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleOutlineRounded';
import ImageElementListItem from './ImageElementListItem';
import { mediaPickerActions } from '../../../MediaPickers/store';
import { createActions } from '../../../store';
import { MAX_IMAGE_ELEMENTS } from '../../../CreatePageConstants';

// The images array is ordered bottom-up like the wave layers, so the list is rendered
// reversed and the newest image appears at the top of the panel.
const ImageElementsEditor = (props) => {
    const {
        imageElementsLength, removeImageElement, duplicateImageElement,
        changeImageElementOrder, openImageElementPicker
    } = props;

    const indexes = useMemo(() =>
        Array.from({ length: imageElementsLength }, (_, i) => i).reverse(),
        [imageElementsLength]
    );

    const elementActions = useMemo(() => ({
        remove: (index) => () => removeImageElement(index),
        moveUp: (index) => imageElementsLength > index + 1 ? () => changeImageElementOrder(index, index + 1) : null,
        moveDown: (index) => index !== 0 ? () => changeImageElementOrder(index, index - 1) : null,
        duplicate: (index) => () => duplicateImageElement(index)
    }), [imageElementsLength, removeImageElement, changeImageElementOrder, duplicateImageElement]);

    return (
        <>
            <List dense disablePadding>
                {indexes.map((index) => (
                    <ImageElementListItem
                        key={index}
                        index={index}
                        remove={elementActions.remove(index)}
                        moveUp={elementActions.moveUp(index)}
                        moveDown={elementActions.moveDown(index)}
                        duplicate={elementActions.duplicate(index)}
                    />
                ))}
            </List>

            <br />
            <Button
                startIcon={<AddIcon />}
                size='small'
                disabled={imageElementsLength >= MAX_IMAGE_ELEMENTS}
                onClick={() => openImageElementPicker()}
            >
                Add Image
            </Button>
        </>
    );
};

const mapStateToProps = (state) => ({
    imageElementsLength: (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images || []).length
});

const mapDispatchToProps = (dispatch) => ({
    removeImageElement: (index) => dispatch(createActions.removeImageElement(index)),
    duplicateImageElement: (index) => dispatch(createActions.duplicateImageElement(index)),
    changeImageElementOrder: (firstIndex, secondIndex) => dispatch(createActions.changeImageElementOrder(firstIndex, secondIndex)),
    openImageElementPicker: () => dispatch(mediaPickerActions.openImageElementPicker())
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementsEditor);
